export const types = {
    TOGGLE_SIDER: 'TOGGLE_SIDER',
};

export const state = {
    isSiderCollapsed: false,
};

export const mutations = {
    [types.TOGGLE_SIDER](state) {
        state.isSiderCollapsed = !state.isSiderCollapsed;
    },
};

export const actions = {
    toggleSider({ commit }) {
        commit(types.TOGGLE_SIDER);
    },
};
